// Prakrit strings used in the interface. All are `needs_review` (docs/09-CONTENT-REVIEW.md #8):
// Hindi and English are always shown beside them until a teacher approves them.

import type { FormRef } from '@/prakrit/lib/grammar/formref'

import { V } from '@/prakrit/lib/grammar/formref'

export interface UiString {
    key: string
    pra: string
    hi: string
    en: string
}

export const TAGLINE: UiString = {
    key: 'ui|tagline',
    pra: 'पाइयं सुहेण सिक्खामो।',
    hi: 'हम प्राकृत आसानी से सीखते हैं।',
    en: 'We learn Prakrit with ease.'
}

export const FIRST_LESSON_TITLE: UiString = {
    key: 'ui|title-u2-pahla-vakya',
    pra: 'मम पढमं पाइय-वक्कं',
    hi: 'मेरा पहला प्राकृत वाक्य',
    en: 'My first Prakrit sentence'
}

export interface RhythmStep {
    n: number
    ref: FormRef
    hi: string
    en: string
}

/** WATCH → LISTEN → UNDERSTAND → INTERACT → BUILD → SPEAK → PRACTISE → REVIEW, as मध्यम पुरुष एकवचन commands. */
export const RHYTHM: RhythmStep[] = [
    { n: 1, ref: V('पास', 'vidhi', 'madhyam', 'eka'), hi: 'देखो', en: 'Watch' },
    { n: 2, ref: V('सुण', 'vidhi', 'madhyam', 'eka'), hi: 'सुनो', en: 'Listen' },
    { n: 3, ref: V('जाण', 'vidhi', 'madhyam', 'eka'), hi: 'समझो', en: 'Understand' },
    { n: 4, ref: V('फास', 'vidhi', 'madhyam', 'eka'), hi: 'छुओ', en: 'Interact' },
    { n: 5, ref: V('णिम्म', 'vidhi', 'madhyam', 'eka'), hi: 'बनाओ', en: 'Build' },
    { n: 6, ref: V('भण', 'vidhi', 'madhyam', 'eka'), hi: 'बोलो', en: 'Speak' },
    { n: 7, ref: V('सीख', 'vidhi', 'madhyam', 'eka'), hi: 'अभ्यास करो', en: 'Practise' },
    { n: 8, ref: V('सर', 'vidhi', 'madhyam', 'eka'), hi: 'याद करो', en: 'Review' }
]

export const UI_STRINGS: UiString[] = [TAGLINE, FIRST_LESSON_TITLE]
